export default {
  browse:{
    table:{
      headers: [
        {
          text: 'No.',
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Event',
          value: 'Event',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Student',
          value: 'Student',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Total Stars',
          value: 'totalStar',
        },
        {
          text: 'Total Score',
          value: 'totalScore',
        },
        {
          text: 'Total Attempts',
          value: 'totalAttempt',
        },
        {
          text: 'Progress',
          value: 'participantProgress',
        },
      ],
    },
  },
  read:{
    tabs:[
      {
        key:'Info',
        label:'info',
      },
    ],
    table:{
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Created',
          value: 'timestampCreated',
          filterable: false,
        },
        {
          text: 'Last Updated',
          value: 'timestampUpdated',
          filterable: false,
        },
      ],
    },
  },
  add:false,
  edit:false,
  delete:false,
}